import Notification from '../message/Message'

export default Notification
